import { findPage } from '../../roles/config';

// Header'dagi joriy sahifa nomi (faqat ko'rinish uchun). Xaritada bo'lmasa — bo'sh.
const PAGE_TITLES = {
  '/': 'Dashboard',
  '/sales': 'Sotuvlar',
  '/students': 'Studentlar',
  '/learning-activity': "O'qish faolligi",
  '/learning-analytics': "O'qish analitikasi",
  '/promo-code': 'Promokodlar',
  '/certificate-holders': 'Sertifikat egalari',
  '/courses': 'Kurslar',
  '/edit-course': 'Kursni tahrirlash',
  '/courses/update-lesson': 'Darsni tahrirlash',
  '/course-details': 'Kurs tafsilotlari',
  '/course-details/chatbot': 'Bob testi',
  '/course/students': 'Kurs studentlari',
  '/new-lesson': 'Video yaratish',
  '/status': 'Video holati',
  '/watch-video': 'Video sahifalari',
  '/history': 'Video yaratish tarixi',
  '/preview': "Ko'rib chiqish",
  '/lesson-preview': "Dars ko'rinishi",
  '/lesson-preview/confirm': 'Darsni tasdiqlash',
  '/lesson-confirmation': 'Tasdiqlash',
  '/new-employee': "Xodim qo'shish",
  '/certificate': 'Sertifikat',
  '/social-media': 'Ijtimoiy tarmoqlar',
  '/about': 'Biz haqimizda',
  '/partners': 'Hamkorlar',
  '/exam-result': 'Imtihon natijalari',
  '/student-info': "Student ma'lumotlari",
  '/notifications/student-complaints': 'Student shikoyatlari',
  '/notifications/teacher-complaints': "O'qituvchi shikoyatlari",
  '/notifications/student-application': 'Student arizalari',
  '/notifications/confirmations': 'Tasdiqlashlar',
};

export function getPageTitle(pathname) {
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  if (path === '/cabinets') return 'Rollar kabinetlari';
  const cabinet = /^\/cabinet\/([^/]+)\/([^/]+)$/.exec(path);
  if (cabinet) return findPage(cabinet[1], cabinet[2])?.label || '';
  return PAGE_TITLES[path] || '';
}
